import React from 'react';
import styled from 'styled-components';
import Timeline from 'react-dual-timeline';
import { StyleRoot } from 'radium';

import achievements from '../../tools/achievements';

const AchievementsContainer = styled.div`
  height: 100%;
  width: 100%;
`;
const AchievementsHeader = styled.h2`
  margin-left: 1rem;
  color: #ed5a5c;
`;
const StyleRootWrapper = styled(StyleRoot)`
  width: 100%;
  height: 80%;
  background-color: #eaeaea;
  overflow: auto;
`;
const TimelineWrapper = styled(Timeline)``;
const TimelineElement = styled.div`
  color: #fff;
`;
const TimelineElementTitle = styled.h4`
  font-family: 'montserrat-b';
  margin: 5px 0 2px;
  color: #ff4858;
`;
const TimelineElementDuration = styled.p`
  font-family: 'montserrat-lt';
  font-size: 13px;
  margin: 0;
  color: #9ace96;
`;
const TimelineElementDescription = styled.p`
  font-family: 'montserrat-r';
  font-size: 15px;
  margin: 5px 0px;
  color: #dadcd2;
`;

const getAchievementsTimeline = () => {
  return achievements.map(achievement => {
    return (
      <TimelineElement key={achievement.key}>
        <TimelineElementTitle>{achievement.name}</TimelineElementTitle>
        <TimelineElementDuration>
          {achievement.duration}
        </TimelineElementDuration>
        <TimelineElementDescription>
          {achievement.description}
        </TimelineElementDescription>
      </TimelineElement>
    );
  });
};

const Achievements = props => {
  return (
    <AchievementsContainer>
      <AchievementsHeader>Achievements</AchievementsHeader>
      <StyleRootWrapper>
        <TimelineWrapper activeColor="#0C7489" animations={false}>
          {getAchievementsTimeline()}
        </TimelineWrapper>
      </StyleRootWrapper>
    </AchievementsContainer>
  );
};

export default Achievements;
